import { createAsyncThunk } from '@reduxjs/toolkit';
import { securedAxiosInstance } from '../../../api/axios';
import moment from 'moment';

export const getReminders = createAsyncThunk(
  'reminders/getReminders',
  async (arg, { rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.get(`/reminders`);
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getLatestReminders = createAsyncThunk(
  'reminders/getLatestReminders',
  async (arg, { rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.get(`/reminders/latest`);
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const saveReminder = createAsyncThunk(
  'reminders/saveReminder',
  async (
    {
      reminderDetail,
      due,
      repeatNum = 1,
      repeatUnit = 'norepeat',
      isUpdate,
      userSelect,
      description,
      dueTime = moment(new Date()).format('HH:mm'),
      goalId = null,
      reminderType = 'reminder',
    },
    { getState, rejectWithValue }
  ) => {
    try {
      let response;
      const data = {
        reminder: reminderDetail,
        deleted: 0,
        due: due,
        due_time: dueTime,
        repeat_num: repeatNum,
        repeat_unit: repeatUnit,
        goal_id: goalId,
        description,
        reminder_type: reminderType,
      };
      if (isUpdate.state) {
        response = await securedAxiosInstance.put(
          `/reminders/${isUpdate.reminder.id}`,
          data
        );
      } else {
        response = await securedAxiosInstance.post(`/reminders`, data);
      }
      // assign users
      if (userSelect) {
        let users = userSelect.map(user => user.value);
        await securedAxiosInstance.post(`/reminders_users`, {
          employees: users,
          reminder_id: response.data,
        });
      }
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const deleteReminder = createAsyncThunk(
  'reminders/deleteReminder',
  async ({ selectedReminders }, { getState, rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.post(
        `/reminders/destroy_bulk`,
        {
          reminders: { reminder_id: selectedReminders },
        }
      );
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
